import { Injectable } from '@angular/core';
import { WidgetsContainerAbstract } from 'src/app/abstract/widgets/widgets-container.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsQuestionModel } from 'src/app/models/widgets/widgets-question.model';
import { WidgetsFormModel } from 'src/app/models/widgets/widgets-form.model';
import { Logger } from 'src/app/core/logger';
import { WidgetsSectionModel } from 'src/app/models/widgets/widgets-section.model';
import { WidgetsService } from './widgets.service';
@Injectable({
  providedIn: 'root',
})
export class WidgetsResequenceService {
  // Used to resequence questions and sections
  private questionSequence: number = 0;
  private sectionSequence: number = 0;

  constructor(
    private logger: Logger,
    private widgetsService: WidgetsService) {
    // Empty
  }

  getLayoutRoot(): WidgetsFormModel {
    return this.widgetsService.getLayoutRoot();
  }

  setLayoutTouched() {
    return this.widgetsService.setLayoutTouched();
  }

  /**
   * Traverse widget tree checking for sections and updating the sequence hierarchy.
   * Note: uses a class private variable sectionSequence
   *
   * @param widget
   * @param parent
   * @returns Number of Sections
   */
  public async resequenceSections(
    widget: WidgetsAbstract,
    parent: WidgetsContainerAbstract
  ): Promise<number> {
    // Starting from top
    if (widget === this.getLayoutRoot()) {
      this.sectionSequence = 0;
    }

    if (widget instanceof WidgetsSectionModel) {
      const sectionWidget = widget as WidgetsSectionModel;

      if (parent instanceof WidgetsSectionModel) {
        // "Subsection": Child of another section
        const parentSection = parent as WidgetsSectionModel;

        if (parentSection.seq && parentSection.seq.length > 0) {
          // Assign the seq from the father
          sectionWidget.seq = Object.assign([], parentSection.seq);
          parentSection.children.forEach((childWidget, index) => {
            if (childWidget.widgetType === WidgetsTypeEnum.SECTION) {
              const section = childWidget as WidgetsSectionModel;
              section.seq.push(index + 1);
              // This triggers the dirty state
              this.setLayoutTouched();
            }
          });
        }
        // this.getNextSection(parentSection);
      } else if (parent instanceof WidgetsFormModel) {
        // Top level section. Child of Form
        // Assign latest section sequence on top level
        const nextSeq = ++this.sectionSequence;
        sectionWidget.seq = [nextSeq];
        // This triggers the dirty state
        this.setLayoutTouched();
      }
    }

    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      container.children.forEach((childWidget) => {
        this.resequenceSections(childWidget, container);
      });
    }

    if (widget instanceof WidgetsSectionModel) {
      const sectionWidget = widget as WidgetsSectionModel;
      // this.logger.log("resequenceSections ("+sectionWidget.label+")");
    }
    return this.sectionSequence;
  }


  /**
   * Traverse widget tree checking for questions and updating the question sequence number.
   * Note: uses a class private variable questionSequence
   *
   * @param widget
   * @param widget
   * @returns true if widgetParent is parent of widget
   */
  public async resequenceQuestions(widget: WidgetsAbstract): Promise<number> {
    // TODO: Move to CommandQuestionService. Save layout before the change to be able to undo.
    if (widget === this.getLayoutRoot()) { this.questionSequence = 0; }

    if (widget instanceof WidgetsQuestionModel) {
      const widgetQuestion = widget as WidgetsQuestionModel;
      widgetQuestion.seq = ++this.questionSequence;
      // This triggers the dirty state
      this.setLayoutTouched();
    }

    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      container.children.forEach((childWidget) => {
        this.resequenceQuestions(childWidget);
      });
    }
    // this.logger.log("Resequencing questions ("+this.questionSequence+")");
    return this.questionSequence;
  }

  public async checkDuplicates(widget: WidgetsAbstract, dbId): Promise<any> {
    if (widget instanceof WidgetsQuestionModel) {
      const widgetQuestion = widget as WidgetsQuestionModel;
      if (widgetQuestion.dbId === dbId) {
        return dbId;
      }
    }
    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      container.children.forEach((childWidget) => {
        this.checkDuplicates(childWidget, dbId);
      });
    }
    return null;
  }

  public async collectDbId(widget: WidgetsAbstract, dbIdArray: number[]): Promise<any> {
    if (widget instanceof WidgetsQuestionModel) {
      const widgetQuestion = widget as WidgetsQuestionModel;
      if (widgetQuestion.dbId !== undefined) {
        dbIdArray.push(widgetQuestion.dbId);
      }
    }
    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      container.children.forEach((childWidget) => {
        this.collectDbId(childWidget, dbIdArray);
      });
    }
    return null;
  }
}
